var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "v-animate-button",
      class: _vm.animateButtonClassNames,
      style: _vm.animateButtonStyles,
    },
    [
      _vm.animating
        ? _c(
            "span",
            {
              staticClass: "animation-content",
              class: _vm.animateContentClassNames,
            },
            [
              _vm.showLoader
                ? _c("span", {
                    staticClass: "animation-loader ld ld-ring ld-spin-fast",
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showIcon
                ? _c(
                    "span",
                    { staticClass: "animation-icon" },
                    [_c("icon", { attrs: { name: _vm.iconStatus } })],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          ref: "originalContent",
          staticClass: "original-content",
          class: { invisible: _vm.animating },
          style: _vm.originalContentStyles,
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }